import { all, takeLatest } from 'redux-saga/effects'

import { productApi } from '../../../services/'
import {
  archiveProductRequest,
  createProductRequest,
  getCompanyProductListRequest,
  getProductDetailRequest,
  updateProductRequest
} from '../actions'
import { archiveProductDetailSaga } from './archiveProduct'
import { createProductSaga } from './createProduct'
import { getCompanyProductListSaga } from './getCompanyProductList'
import { getProductDetailSaga } from './getProductDetail'
import { updateProductSaga } from './updateProduct'

export function* productSaga() {
  try {
    yield all([
      takeLatest(
        getCompanyProductListRequest as any,
        getCompanyProductListSaga,
        productApi
      ),
      takeLatest(
        getProductDetailRequest as any,
        getProductDetailSaga,
        productApi
      ),
      takeLatest(createProductRequest as any, createProductSaga, productApi),
      takeLatest(updateProductRequest as any, updateProductSaga, productApi),
      takeLatest(
        archiveProductRequest as any,
        archiveProductDetailSaga,
        productApi
      )
    ])
  } catch (err) {
    // TODO: handle error
  }
}
